import { render, staticRenderFns } from "./custom-tooltip.vue?vue&type=template&id=0a776802"
import script from "./custom-tooltip.vue?vue&type=script&lang=js"
export * from "./custom-tooltip.vue?vue&type=script&lang=js"
import style0 from "./custom-tooltip.vue?vue&type=style&index=0&id=0a776802&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_171207/resources/assets/marketplace/components/BaseButton.vue').default})
